import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { IState } from './types/reducer';
import shopActions from 'services/shop/actions';
import { CATEGORY_CODE_NEED_CALL_SHOP } from './constant';
import { IServiceUI } from 'types/service';
import { ICategoryUI } from 'types/category';

const initialState: IState = {
  detail: null,
  successBooking: null,
  transactionDetail: {
    data: null,
    loading: true,
  },
  pureCategories: [],
  categories: [],

};

export const Slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.category, (state, { payload }) => {
        state.pureCategories = payload;
      })
      .addCase(actions.services.fetch, (state) => {
        state.categories = [];
      })
      .addCase(actions.services.success, (state, { payload }) => {
        state.categories = state.pureCategories.map((o) => ({
          id: o.id?.toString(),
          name: o.categoryName,
          code: o.code,
          services: payload.filter(s => s.catId === o.id).map(s => ({
            cateId: o.id?.toString(),
            id: s.id?.toString(),
            image: s.urlImage,
            name: s.serviceName,
            duration: s.duration,
            price: s.price,
            needCallShop: CATEGORY_CODE_NEED_CALL_SHOP.includes(o.code || ''),
          }) as IServiceUI),
        })).filter(o => o.services.length > 0) as ICategoryUI[] || [];
      })

      .addCase(actions.getTransactionDetail.fetch, (state) => {
        state.transactionDetail.data = null;
        state.transactionDetail.loading = true;
      })
      .addCase(actions.getTransactionDetail.success, (state, { payload }) => {
        state.transactionDetail.data = payload;
        state.transactionDetail.loading = false;
      })
      .addCase(actions.getTransactionDetail.fail, (state) => {
        state.transactionDetail.loading = false;
      })
      .addCase(actions.detail.success, (state, { payload }) => {
        state.detail = payload;
      })
      .addCase(actions.setSuccessData, (state, { payload }) => {
        state.successBooking = payload;
      })

      ;
  },
});
const aptServiceReducer = Slice.reducer;
export default aptServiceReducer;
